<template>
  <div :key="form_id">

    <page-title :page-title="formName"></page-title>

    <div class="pt-6 px-md-8 px-4" v-if="loadingForm">
      <v-container fluid>
        <v-row>
          <v-col class="pa-0">
            <v-skeleton-loader type="text@2, sentences, text@3, image, text@3"></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <form-fill-core
        v-if="!loadingForm"
        :form="myForm"
        :registration_id="registration_id"
        :saved_registration_id="saved_registration_id"
        @savingComplete="onSavingComplete"
        ref="formFillCore"
    />

    <!-- Success dialog when registration is completed -->
    <v-dialog v-model="savingComplete" max-width="400" scrollable @click:outside="goToOverview">
      <v-card>
        <v-card-text class="pt-4 text-center">
          <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>
          <p class="mt-5">Uw registratie is verstuurd.</p>

          <v-btn class="mx-1 my-2" depressed color="primary" v-on:click="goToOverview">
            Gereed
          </v-btn>

          <template v-if="formType !== 'workflow'">
            <v-btn
                depressed
                outlined
                color="primary"
                v-on:click.prevent="fillFormAgain"
                class="mx-1 my-2"
            >
              Nogmaals invullen
            </v-btn>
          </template>

        </v-card-text>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>

  </div>
</template>
<script>
import PageTitle from "@/components/Pagetitle";
import FormFillCore from "@/views/forms/FormFillCore.vue";
import axios from "axios";

export default {
  name: "FormFill",
  components: {
    FormFillCore,
    PageTitle,
  },
  props: {
    /**
     * The ID of the form to fill in.
     */
    form_id: {
      type: String,
      required: true,
    },
    /**
     * The registration ID of a saved (unsend) registration.
     */
    saved_registration_id: {
      type: String,
      required: false,
    },
    /**
     * Registration ID is used to edit a registration. Used to reload an existing registration and used to load a workflow registration.
     */
    registration_id: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      myForm: null,
      loadingForm: true,
      savingComplete: false,
    }
  },
  async mounted() {
    await this.loadForm()
  },
  computed: {
    formName() {
      if (this.myForm) {
        return this.myForm.form_name ? this.myForm.form_name : ''
      }
      else {
        return 'Laden..'
      }
    },
    formType() {
      if (this.myForm) {
        return this.myForm.form_type ? this.myForm.form_type : ''
      }
      else {
        return ''
      }
    },
  },
  methods: {
    async loadForm() {
      this.loadingForm = true
      // Fetch results form the API
      await axios
          .get('api/form/' + this.form_id)
          .then(response => {
            this.myForm = response.data
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => this.loadingForm = false)
    },
    onSavingComplete() {
      this.savingComplete = true;
    },
    goToOverview() {
      // Go to forms overview
      this.$router.push({name: "folder_list"});
    },
    fillFormAgain() {
      // Refresh page. Dont use this.$router.go() because it does not work on iOS.
      window.location.reload();
    },
    confirmClose() {
      let formFillCore = this.$refs.formFillCore;
      let unsavedChanges = formFillCore ? formFillCore.unsavedChanges : false;

      if (unsavedChanges) {
        return window.confirm('Wilt u deze pagina verlaten? Indien u wijzigingen heeft aangebracht gaan deze verloren.');
      }
      return true;
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.confirmClose()) {
      this.$toast.clear();
      next();
    }
    else {
      next(false);
    }
  },
}
</script>

<style lang="scss">

</style>